define 'lib/formdata', ['jquery'], ($) ->
  $.fn.serializeObject = ->
    array = @serializeArray()
    result = {}
    for entry in array
      result[entry.name] = entry.value
    result